import React from 'react';

function TextResultView(props : { text: string }) {
    return <p>{props.text}</p>;
}

export default TextResultView;